import React from "react";
import { Link } from "react-router-dom";
import { TrendingUp, Calculator, MapPin, LineChart, ArrowRight } from "lucide-react";

const TOOLS = [
  { icon: TrendingUp, title: "Instant valuation", desc: "What's your home worth today?", to: "/#valuation" },
  { icon: Calculator, title: "Mortgage & stamp duty", desc: "Crunch the numbers in seconds", to: "/calculators" },
  { icon: MapPin, title: "Area guides", desc: "Schools, commute & lifestyle", to: "/area-guides" },
  { icon: LineChart, title: "Home value tracker", desc: "Watch your equity grow", to: "/#valuation" },
];

const ToolsBand = () => (
  <section className="py-20 bg-white" data-testid="tools-band">
    <div className="max-w-[1180px] mx-auto px-5 md:px-8">
      <p className="text-[12px] tracking-[0.28em] uppercase text-[#b8935f] mb-3">Property tools</p>
      <h2 className="font-display text-[32px] md:text-[40px] font-300 text-[#2b2b2b] mb-10">Everything you need, in one place</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {TOOLS.map((t) => (
          <Link key={t.title} to={t.to} className="group bg-[#faf7f2] rounded-2xl border border-[#f0ece5] p-6 hover:border-[#b8935f] hover:-translate-y-0.5 transition-all" data-testid="tool-card">
            <span className="w-11 h-11 rounded-xl bg-white border border-[#f0ece5] flex items-center justify-center mb-4 group-hover:bg-[#b8935f] transition-colors">
              <t.icon size={20} className="text-[#b8935f] group-hover:text-white transition-colors" />
            </span>
            <p className="font-display text-[18px] font-500 text-[#2b2b2b]">{t.title}</p>
            <p className="text-[13px] text-[#8a8a8a] mt-1">{t.desc}</p>
            <span className="inline-flex items-center gap-1 text-[13px] text-[#b8935f] mt-3">Open <ArrowRight size={14} className="group-hover:translate-x-0.5 transition-transform" /></span>
          </Link>
        ))}
      </div>
    </div>
  </section>
);

export default ToolsBand;
